import React from "react";



const AboutMe = ()=>{



    return (
        <>
        <div id="about-me-container">
            <p className="about-me-text gen-text">
            Hi! My name is Kyle and I would best describe myself as an inquisitive mind. I am easily awed by all the amazing skills people hone and the projects they are able to produce as a result. Dipping my toes in many different fields ranging from carpentry and maintenance to analytical chemistry, I've had the opportunity of seeing how people path themselves toward mastery of their craft. 
            <br/>
            <br/>
            I took interest in computer science during COVID after seeking a career change from chemistry. At the time one of my best friends recently finished earning his master's in CS and I had always been intrigued at the kind of work he did. Knowing very little about the field we just talked about computer science; what he does with it and what it is in its essence. Simply put, it's all problem solving. Identifying how something can be done or if it can be done and taking the steps to test and confirm. The only limit of what CS can do is what you can imagine. Rewarding curiosity? Sounds right up my alley!
            <br/>
            <br/>
            He encouraged me to give it a try and fast forward a year later, I've graduated from Fullstack Academy's Web Development bootcamp and make applications I would've never dreamed of creating using technologies I never knew existed. There's an endless road ahead but I am looking forward to carving my own path toward mastery of this massive field!

            
            </p>
        </div>
        </>
    )
}

export default AboutMe
